import { useEffect, useState } from "react";
import Header from "../components/Header";
import Nav from "../components/Nav";

import Carousel from "../components/carousel";
import CategoryCard from "../components/category-card.component";
import categories from "../statics/categories";
import Loader from "../components/Loader";
import api from "../statics/api.js"
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import ProductVertical from "../components/product-vertical.component";
import ProductHorizontal from "../components/product-horizontal.component.jsx";
import Footer from "../components/footer.component.jsx";
import { set_username } from "../reducers/username";
import { set_cart } from "../reducers/cart";

import { useDispatch, useSelector } from "react-redux";
import SearchInput from "../components/search-input.component.jsx";
import Overlay from "../components/Overlay.jsx";
import BottomNav from "../components/bottom-nav.component.jsx";
import Cart from "../components/cart.compontent.jsx";
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import MobileMenu from "../components/menu.component.jsx";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";


function PrivcayPolicy() {
    const [isSearching, setIsSearching] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSearchClick = () => {
        setIsSearching((prev) => !prev);
    };

    useState(()=>{
        window.scroll(0,0)
    },[])
    return (
        <>
            <Nav></Nav>
            <Header onSearchClick={handleSearchClick}></Header>

            <Helmet>
                <title>PuZzLe Technology Computer Store | Privacy Policy </title>
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"></meta>
                <meta name='description' content="سياسات الخصوصية الخاصة بالموقع" />
                <meta name="keywords" content="PuZzLe Technology, puzzle tech, موقع بازل, موقع البازل, بازل تكنولوجي, محل بازل"></meta>
            </Helmet>

            <h2 className="text-white text-2xl text-center mt-4">Privacy Policy</h2>
            <div class="privacy-policies">
                <div class="text-white max-w-[800px] mx-8">

                    <h3>Return and Replacement Policy</h3>
                    <ol>
                        <li>
                            <strong>Agent Warranty:</strong>
                            <p>Products are guaranteed by the agent for 3 years from the purchase date.</p>
                        </li>

                        <li>
                            <strong>Product Returns (Under Conditions):</strong>
                            <ol>
                                <li>Customers may request to return products within 14 days of receipt.</li>
                                <li>
                                    <strong>Return Conditions:</strong>
                                    <ol>
                                        <li>Product must be in the same condition as purchased (unopened/unused).</li>
                                        <li>If returned via shipping companies, the customer bears the shipping costs.</li>
                                    </ol>
                                </li>
                            </ol>
                        </li>

                        <li>
                            <strong>Replacement of Defective Products:</strong>
                            <ol>
                                <li>Products with manufacturing defects may be replaced, depending on the product nature.</li>
                                <li>
                                    <strong>Replacement Process:</strong>
                                    <ol>
                                        <li>Contact customer service via the designated WhatsApp number.</li>
                                        <li>Provide complete details about the product defect.</li>
                                    </ol>
                                </li>
                            </ol>
                        </li>

                        <li>
                            <strong>Company's Right to Refuse Requests:</strong>
                            <p>The company reserves the full right to reject any return or replacement request that doesn't comply with the stated terms and conditions.</p>
                        </li>

                        <li>
                            <strong>Refund Process:</strong>
                            <p>For payments made via electronic gateways or direct links:</p>
                            <ol>
                                <li>Refunds will be issued to the same payment card used.</li>
                                <li>Refund processing may take up to 14 business days.</li>
                            </ol>
                        </li>
                    </ol>

                    <hr class="my-4" />
                    <p><strong>Note:</strong> Please ensure all conditions are met before submitting any return or replacement request.</p>
                </div>
            </div>



            <BottomNav currentPage={""}></BottomNav>
            <Footer></Footer>
            {loading ?
                <Loader></Loader>
                : null
            }
            {
                isSearching ?
                    <>
                        <SearchInput></SearchInput>
                        <div onClick={() => setIsSearching(false)}>
                            <Overlay></Overlay>
                        </div>
                    </> : null
            }
            {/* <TawkMessengerReact
                propertyId={process.env.REACT_APP_CHAT_PROPERTY_ID}
                widgetId={process.env.REACT_APP_CHAT_WIDGET_ID} /> */}
            <ToastContainer></ToastContainer>
            <Cart></Cart>
            <MobileMenu></MobileMenu>

        </>
    )
}

export default PrivcayPolicy;